import {
  grayColor,
  cardTitle,
} from "assets/jss/material-dashboard-pro-react.js";

const monthlyPLStyle = () => ({
  plWrapperOuter: {
    paddingLeft: "4px",
    paddingRight: "4px",
  },
  cardTitle: {
    ...cardTitle,
    marginTop: "0px",
    marginBottom: "3px",
  },
  cardTitleWaiting: {
    color: grayColor[3],
  },
  graphLegend: {
    marginTop: "10px",
    fontSize: "12px",
    color: grayColor[0],
    lineHeight: "1.2",
  },
});

export default monthlyPLStyle;
